import { MERCHANTS_TABS } from '../utils/merchantUtils';
import MerchantBusinessPage from '../views/merchants/details/MerchantBusinessPage';
import MerchantAddressPage from '../views/merchants/details/MerchantAddressPage';
import MerchantContactPage from '../views/merchants/details/MerchantContactPage';
import MerchantBankPage from '../views/merchants/details/MerchantBankPage';
import MerchantCustomerSupportPage from '../views/merchants/details/MerchantCustomerSupportPage';
import MerchantDeveloperPage from '../views/merchants/details/MerchantDeveloperPage';
import MerchantSpecialTermsPage from '../views/merchants/details/MerchantSpecialTermsPage';
import { MerchantFeesPage } from '../views/merchants/details/MerchantFeesPage';
import { MerchantSitesPage } from '../views/merchants/details/MerchantSitesPage';
import { MerchantConfigurationPage } from '../views/merchants/details/MerchantConfigurationPage';
import { MerchantFeesHistoryPage } from '../views/merchants/details/MerchantFeesHistoryPage';
import { MerchantPaymentGatewayPage } from '../views/merchants/details/MerchantPaymentGatewayPage';
import { MerchantWebhooksListPage } from '../views/merchants/details/MerchantWebhooksListPage';
import { ApiKeysPage } from '../views/developers/ApiKeysPage';
import { WebhookCreateComponent } from '../components/developers/webhooks_page/WebhookCreateComponent';
import { MerchantCheckoutConfigurationPage } from '../views/merchants/details/MerchantCheckoutConfigurationPage';
import { MerchantWidgetConfigurationsPage } from '../views/merchants/details/MerchantWidgetConfigurationsPage';
import { SenseJS } from '../components/developers/sites/SenseJS';
import { MerchantOwnerPage } from '../views/merchants/details/MerchantOwnerPage';
import { MerchantFundReservePage } from '../views/merchants/details/MerchantFundReservePage';
import { CLAIMS } from '../utils/roles-helper';
import MerchantWorkflowsPage from '../views/merchants/details/MerchantWorkflowsPage';
import { MerchantDocumentsPage } from '../views/merchants/details/MerchantDocumentsPage';

export const MERCHANT_BASE_URL = '/accounts/merchants/:id';

export const merchantRoutes = [
  {
    key: MERCHANTS_TABS.BASE,
    pathname: `${MERCHANT_BASE_URL}`,
    component: <MerchantBusinessPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.BUSINESS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.BUSINESS}`,
    component: <MerchantBusinessPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.ADDRESS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.ADDRESS}`,
    component: <MerchantAddressPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.OWNER,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.OWNER}`,
    component: <MerchantOwnerPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.CONTACT,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.CONTACT}`,
    component: <MerchantContactPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.CUSTOMER,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.CUSTOMER}`,
    component: <MerchantCustomerSupportPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.DEVELOPER,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.DEVELOPER}`,
    component: <MerchantDeveloperPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.BANK,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.BANK}`,
    component: <MerchantBankPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.FEES,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.FEES}`,
    component: <MerchantFeesPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.SITES,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.SITES}`,
    component: <MerchantSitesPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.CHECKOUT_CONFIGURATIONS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.SITES}/:siteId/${MERCHANTS_TABS.CHECKOUT_CONFIGURATIONS}`,
    component: <MerchantCheckoutConfigurationPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.WIDGET_CONFIGURATIONS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.SITES}/:siteId/${MERCHANTS_TABS.WIDGET_CONFIGURATIONS}`,
    component: <MerchantWidgetConfigurationsPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.SENSE_JS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.SITES}/:siteId/${MERCHANTS_TABS.SENSE_JS}`,
    component: <SenseJS />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.FUNDS_RESERVE,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.FUNDS_RESERVE}`,
    component: <MerchantFundReservePage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.SPECIAL_TERMS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.SPECIAL_TERMS}`,
    component: <MerchantSpecialTermsPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.CONFIGURATIONS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.CONFIGURATIONS}`,
    component: <MerchantConfigurationPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.WORKFLOWS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.WORKFLOWS}`,
    component: <MerchantWorkflowsPage />,
    claim: CLAIMS.SUPER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.FEES_HISTORY,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.FEES_HISTORY}`,
    component: <MerchantFeesHistoryPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.PAYMENT_GATEWAY,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.PAYMENT_GATEWAY}`,
    component: <MerchantPaymentGatewayPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.WEBHOOKS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.WEBHOOKS}`,
    component: <MerchantWebhooksListPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: `${MERCHANTS_TABS.WEBHOOKS}-webhookId`,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.WEBHOOKS}/:webhookId`,
    component: <WebhookCreateComponent />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.API_KEY,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.API_KEY}`,
    component: <ApiKeysPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
  },
  {
    key: MERCHANTS_TABS.DOCUMENTS,
    pathname: `${MERCHANT_BASE_URL}/${MERCHANTS_TABS.DOCUMENTS}`,
    component: <MerchantDocumentsPage />,
    claim: CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN,
  },
];
